import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ResidentNotifications from './index.vue';

export { RESIDENT_LK_NOTIFICATIONS_TAB_ID } from './notification-api';

const MOUNT_ID = 'residentNotificationsListApp';

let residentNotificationsApp: App<Element> | null = null;
let currentMountEl: HTMLElement | null = null;

export function initResidentNotifications(root?: ParentNode): void {
  const mountEl = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (!mountEl) {
    return;
  }

  if (residentNotificationsApp && currentMountEl) {
    residentNotificationsApp.unmount();
    currentMountEl.innerHTML = '';
  }

  const app = createApp(ResidentNotifications);

  app.use(AntDesignVue).mount(mountEl);

  residentNotificationsApp = app;
  currentMountEl = mountEl;
}
